<div class="container" id="shell-container">
    <div class="header">
        <app-header [showImage]="isHomePage" (nextPage)="getDataAndRedirect($event)"></app-header>
    </div>
    <div class="content">
        <router-outlet></router-outlet>
    </div>

    <div class="footer">
        <app-footer></app-footer>
    </div>
</div>
